import { getEnv } from '@/util/env.js';

let universalBridge = {};
/** 
 * 初始化 Universal Bridge
 * @doc https://nio.feishu.cn/wiki/wikcn7dazoFseAV8VXprAt1HtLe
 */
export function initUniversalBridge() {
    return import(`@nio-wad/universal-bridge-h5`).then(
        async ({ nioJsBridge }) => {
            universalBridge = nioJsBridge;
            console.log('[universalBridge]', universalBridge);
        }
    );
}

// tools
export function isInNioCNApp() {
    const inApp = universalBridge.currentInNioCNApp
        ? universalBridge.currentInNioCNApp()
        : false;

    console.log('[isInNioCNApp]', inApp);
    return inApp;
}

export function isInLg() {
    if (universalBridge.currentInLgContainer) {
        return universalBridge.currentInLgContainer();
    }
    return false;
}

export function handleBridgeCallback(res, success, error) {
    try {
        if (res.result_code !== 'success') {
            throw res;
        }

        success && success(res);
        return res;
    } catch (e) {
        error && error(e);
        return e;
    }
}

/**
 * 打开新页面
 * @param {string} url
 */
export function redirectToViewBridge(url) {
    return universalBridge.openURL({ data: { url } });
}

/** 跳转至客户端登陆页 */
export function redirectToLoginViewBridge() {
    return universalBridge.openLoginPage();
}

/** 获取登录用户信息 */
export async function getLoginInfoBridge(params = {}) {
    const raw = await universalBridge.getUserInfo({
        data: {
            env: getEnv(), // 涉及到回调接口，要感知环境
            uniLogin: true,
            autoJump: false,
            redirectUrl: encodeURIComponent(window.location.href),
            customQuery: {},
            ...params
        }
    });
    const { data = {}, result_code, display_message } = raw || {};
    const result = {
        result_code,
        display_message,
        data: {
            access_token: data.access_token,
            country_code: data.mobile
                ? data.mobile.calling_code || data.mobile.callingCode || '86'
                : '', // android没有
            mobile: data.mobile ? data.mobile.mobile : '',
            token_type: data.token_type || 'Bearer',
            account_id: data.account_id
        }
    };

    console.log('[getLoginInfoBridge]', raw);
    return result;
}

/**
 * 获取当前位置经纬度
 * @param {object} context 
 * @param {object} context.data 
 * @param {string} [context.data.type] 经纬度类型
 * @param {boolean} [context.central] 是否做页面降级处理（仅针对小程序）
 */
export async function getLocationBridge(context) {
    const raw = await universalBridge.getLocation({
        data: { type: 'gcj-02' },
        ...context
    });
    const { data = {}, result_code, display_message } = raw || {};

    console.log('[getLocationBridge]', raw);
    return {
        result_code,
        display_message,
        data: {
            // ...data,
            lat: data.latitude,
            lng: data.longitude
        }
    };
}

/** 
 * 复制文本
 * @param {string} content 复制的文本
 */
export function copyBridge(content) {
    return universalBridge.setCopyText({
        data: { content }
    });
}

/** 关闭当前H5页面 */
export function closePageBridge() {
    return universalBridge.close();
}

/**
 * 一键加群
 * @param {object} data
 * @param {string} data.groupId 群ID
 * @param {string} data.inviterId 邀请人ID
 */
export function applyJoinGroupBridge(groupId, inviterId) {
    return universalBridge.applyJoinGroup({
        data: { group_id: groupId, inviter_id: inviterId }
    });
}

/** 
 * 显示客户端loading动画
 * @param {string} content loading的文本
 */
export function showNativeLoading(content) {
    return universalBridge.showLoading({
        data: { content: content }
    });
}

/** 
 * 停止客户端loading动画
 * @param {string} content loading的文本
 */
export function destroyNativeLoading(content) {
    return universalBridge.hideLoading({
        data: { content: content }
    });
}



// WEBPACK FOOTER //
// ./src/util/platform/universal-bridge.js